module.exports = __webpack_public_path__ + "img/ok.b4023e77.svg";